import { memo } from 'react';

const SubjectIcon = () => {
  return (
    <svg width="60" height="16" viewBox="0 0 60 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="16" rx="8" fill="#03BCD4" />
      <path
        d="M12.6049 5.09309C12.6049 5.09309 11.3628 5.00013 9.93425 5.00013C8.49687 4.99168 8 5.38885 8 6.44514V6.94371C8 7.8479 8.47025 7.9324 9.41964 8.09296C9.71244 8.14366 11.0433 8.37182 11.4692 8.45633C11.7798 8.50703 11.8419 8.66759 11.8419 8.88729V9.32671C11.8419 9.86754 11.6378 9.97739 10.928 9.97739H8.00887L8 10.8985C8 10.8985 9.63258 10.9914 11.0611 10.9914C12.5073 10.9999 12.9776 10.5605 12.9776 9.50417V8.73519C12.9776 7.98311 12.7203 7.66199 11.8419 7.50144C11.4249 7.42538 9.60596 7.10427 9.60596 7.10427C9.25993 7.03667 9.16233 6.97751 9.16233 6.724V6.54655C9.16233 6.04798 9.29542 6.01417 9.89876 6.01417H12.5961L12.6049 5.09309Z"
        fill="black"
      />
      <path
        d="M15.8763 9.20841V5.04238H14.7406V9.40277C14.7406 10.3408 15.3439 10.9745 16.4619 10.9745H18.2009C19.3189 10.9745 19.9222 10.3408 19.9222 9.40277V5.04238H18.7865V9.20841C18.7865 9.76613 18.5292 10.0196 17.917 10.0196H16.7458C16.1336 10.0196 15.8763 9.76613 15.8763 9.20841Z"
        fill="black"
      />
      <path
        d="M21.9897 10.9576H25.3258C26.4438 10.9576 27.0471 10.4084 27.0471 9.47037V8.87039C27.0382 8.33802 26.6656 8.00001 26.1332 7.831C26.6035 7.66199 26.9051 7.34933 26.914 6.85076V6.5212C26.914 5.58321 26.3107 5.04238 25.1927 5.04238H21.9897V10.9576ZM23.1254 8.34647H25.0419C25.6541 8.34647 25.9558 8.51548 25.9558 8.94645V9.20841C25.9558 9.76613 25.6985 10.0196 25.0862 10.0196H23.1254V8.34647ZM25.8227 6.88456C25.8227 7.30708 25.5299 7.43383 24.9354 7.44228H23.1254V5.97192H24.9531C25.5654 5.97192 25.8227 6.14093 25.8227 6.69865V6.88456Z"
        fill="black"
      />
      <path
        d="M28.5927 10.9069C28.5927 10.9069 29.4534 10.9999 30.5713 10.9999C31.6804 11.0083 32.4612 10.5605 32.4612 9.51262V5.04238H31.3255V9.21686C31.3255 9.77458 31.0682 10.0281 30.456 10.0281H28.5927V10.9069Z"
        fill="black"
      />
      <path
        d="M34.5259 10.9576H38.9179V9.96049H35.6616V8.43943H38.5275V7.46763H35.6616V5.98882H38.9267V5.04238H34.5259V10.9576Z"
        fill="black"
      />
      <path
        d="M45.362 5.06773C45.362 5.06773 44.0754 5.00013 42.4251 5.00013C41.316 4.99168 40.757 5.67616 40.757 6.61415V9.30136C40.757 10.2394 41.316 11.0083 42.4251 10.9999C43.8979 10.9999 45.362 10.9154 45.362 10.9154L45.3531 10.0281H42.8865C42.2742 10.0281 41.9726 9.73233 41.9726 9.17461V6.7409C41.9726 6.18318 42.2742 5.97192 42.8865 5.97192H45.3531L45.362 5.06773Z"
        fill="black"
      />
      <path
        d="M52 5.04238H46.8627V5.97192H48.8679V10.9576H50.0036V5.97192H52V5.04238Z"
        fill="black"
      />
    </svg>
  );
};

export default memo(SubjectIcon);
